export default __webpack_public_path__ + "static/media/sel_calendar.4119b544.svg";